<mat-form-field>
  <input matInput [matDatepicker]="dp" placeholder="Elija més y año" [formControl]="monthCtrl" readonly>
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, dp)" panelClass="month-picker">
  </mat-datepicker>
</mat-form-field>
